// extracted by mini-css-extract-plugin
export default {"container":"MainCompanyInfo_container__Irplg","info":"MainCompanyInfo_info__N-yOl","symb":"MainCompanyInfo_symb__h-MhJ","mainStaticBlock":"MainCompanyInfo_mainStaticBlock__EDA3Q"};